export default "__VITE_ASSET__yioi1iHy__"